var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":_vm.watchlistUpdate}},[_c('v-icon',[_vm._v(_vm._s(_vm.is_watchlisted ? "mdi-star" : "mdi-star-outline"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }